<ng-container *ngIf="!monthly; else monthlyPicker">
  <div
    class="nudge-period-notice"
    *ngIf="nudgeSplit && !nudgeNoticeDismissed"
    role="status"
  >
    <span class="nudge-period-notice-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.7" />
        <path d="M12 11v5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
        <circle cx="12" cy="8" r="1" fill="currentColor" />
      </svg>
    </span>
    <div class="nudge-period-notice-content">
      <p class="nudge-period-notice-title">{{ 'nudge_period_title' | translate }}</p>
      <p class="nudge-period-notice-description">{{ 'nudge_period_summary' | translate }}</p>
    </div>
    <button
      type="button"
      class="nudge-period-notice-dismiss"
      [attr.aria-label]="'words.close' | translate"
      (click)="nudgeNoticeDismissed = true"
    >
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="m4 4 8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </button>
  </div>
  <div class="date-range-container">
    <div class="date-column">
      <h2>
        {{ "phrases.start_date" | translate }}:
        {{ startDate | date: "MMM d, y" : undefined : currentLang }}
      </h2>
      <mat-calendar
        *ngIf="renderCalendars"
        [(selected)]="startDate"
        (selectedChange)="onStartSelect($event)"
        [startAt]="startDate"
        [minDate]="startMinDate"
        [maxDate]="startMaxDate"
        [dateClass]="dateRangeClass"
      ></mat-calendar>
    </div>

    <div class="date-column">
      <h2>
        {{ "phrases.end_date" | translate }}:
        {{ endDate | date: "MMM d, y" : undefined : currentLang }}
      </h2>
      <mat-calendar
        *ngIf="renderCalendars"
        [(selected)]="endDate"
        (selectedChange)="onEndSelect($event)"
        [minDate]="startDate"
        [startAt]="endDate || startDate"
        [maxDate]="endMaxDate"
        [dateClass]="dateRangeClass"
      ></mat-calendar>
    </div>
  </div>
</ng-container>

<ng-template #monthlyPicker>
  <div class="monthly-picker-container">
    <div class="monthly-picker-header">
      <h2>Select invoice date</h2>
      <mat-checkbox
        *ngIf="allowRangeToggle"
        [checked]="isDateRange"
        (change)="onDateRangeToggle($event.checked)"
        class="monthly-picker-checkbox"
      >
        Is Date Range
      </mat-checkbox>
    </div>

    <div class="monthly-picker-fields">
      <div class="monthly-picker-field">
        <span class="monthly-picker-label">
          {{ isDateRange ? "Start date" : "Date" }}
        </span>
        <button
          type="button"
          mat-stroked-button
          class="month-select-button"
          (click)="startMonthPicker.open()"
        >
          {{ formatSelectedDate(startDate) }}
        </button>
        <input
          class="month-picker-hidden-input"
          matInput
          [matDatepicker]="startMonthPicker"
          [value]="startDate"
          readonly
        />
        <mat-datepicker
          #startMonthPicker
          startView="multi-year"
          panelClass="month-picker-panel"
          (monthSelected)="onStartMonthSelected($event, startMonthPicker)"
        ></mat-datepicker>
      </div>

      <div class="monthly-picker-field" *ngIf="isDateRange">
        <span class="monthly-picker-label">End date</span>
        <button
          type="button"
          mat-stroked-button
          class="month-select-button"
          (click)="endMonthPicker.open()"
        >
          {{ formatSelectedDate(endDate) }}
        </button>
        <input
          class="month-picker-hidden-input"
          matInput
          [matDatepicker]="endMonthPicker"
          [min]="startDate"
          [value]="endDate"
          readonly
        />
        <mat-datepicker
          #endMonthPicker
          startView="multi-year"
          panelClass="month-picker-panel"
          (monthSelected)="onEndMonthSelected($event, endMonthPicker)"
        ></mat-datepicker>
      </div>
    </div>
  </div>
</ng-template>

<div class="date-range-buttons">
  <button mat-button (click)="onCancel()">
    {{ "words.cancel" | translate }}
  </button>
  <button
    mat-raised-button
    class="primary"
    (click)="onApply()"
    [disabled]="!canApply()"
  >
    {{ "words.apply" | translate }}
  </button>
</div>
